import { render, staticRenderFns } from "./my-card.vue?vue&type=template&id=2b323476&scoped=true&"
import script from "./my-card.vue?vue&type=script&lang=js&"
export * from "./my-card.vue?vue&type=script&lang=js&"
import style0 from "./my-card.vue?vue&type=style&index=0&id=2b323476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b323476",
  null
  
)

export default component.exports